<template>
  <div>
    <button
      v-if="wantsDarkMode"
      class="btn btn-sm p-1 text-white"
      @click="disable"
    >
      <PhLightbulb />
    </button>
    <button v-else class="btn btn-sm p-1 text-gray-600" @click="enable">
      <PhLightbulb weight="fill" />
    </button>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { PhLightbulb } from "@phosphor-icons/vue";

const wantsDarkMode = ref(false);

const enable = () => {
  wantsDarkMode.value = true;
  deleteCookie("wants_light_mode");
  setCookie("wants_dark_mode");
  toggleClass();
};

const disable = () => {
  wantsDarkMode.value = false;
  deleteCookie("wants_dark_mode");
  setCookie("wants_light_mode");
  toggleClass();
};

const deleteCookie = (name) => {
  document.cookie =
    name +
    "=checked;path=/;expires=" +
    new Date(Date.now() - 1000).toUTCString();
};

const setCookie = (name) => {
  document.cookie =
    name +
    "=checked;path=/;expires=" +
    new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
};

const toggleClass = () => {
  const pageContainer = document.getElementById("main_container");
  if (pageContainer) {
    pageContainer.classList.toggle("dark");
  }
};

onMounted(() => {
  const cookies = document.cookie.split(";").map((cookie) => {
    const [name] = cookie.split("=");
    return name.trim();
  });

  const wantsDarkModeCookie = cookies.includes("wants_dark_mode");
  const wantsLightModeCookie = cookies.includes("wants_light_mode");

  if (wantsLightModeCookie) {
    wantsDarkMode.value = false;
  } else if (wantsDarkModeCookie) {
    wantsDarkMode.value = true;
  } else if (matchMedia && matchMedia("(prefers-color-scheme: dark)").matches) {
    enable();
  }
});
</script>
